import Modifier from 'ember-modifier';
import { next } from '@ember/runloop';

export default class WithInitialFocus extends Modifier {
  modify(element) {
    next(this, function () {
      element.focus();
    });
  }
}
